import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'ess-column-right',
  templateUrl: './column-right.component.html',
  styleUrls: ['./column-right.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ColumnRightComponent {}
